<template>
    <div class="ml-auto d-flex align-items-center">
        <button type="button" class="btn btn-pill btn-primary" @click="multiply = parseInt(multiply) - 1" :disabled="multiply === 1"><i class="fa fa-minus"></i></button>
        <div class="mx-2 multiply-recipe">
            <div class="small-text">cooking for</div>
            <div class="multiply">{{ multiply }}</div>
            <div class="small-text">people</div>
        </div>
        <button type="button" class="btn btn-pill btn-primary" @click="multiply = parseInt(multiply) + 1" :disabled="multiply === 6"><i class="fa fa-plus"></i></button>
    </div>
</template>

<script>

export default {
name: "MultiplyControls",
    computed: {
        multiply: {
            get() {
                return this.$store.getters['Settings/multiply']
            },
            set(val) {
                this.$store.dispatch('Settings/updateMultiply', val)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.multiply-recipe {
    text-align: center;
    .small-text {
        font-size: 12px;
    }
    .multiply {
        font-size: 25px;
        font-weight: bold;
    }
}
</style>
